import { render, staticRenderFns } from "./loading6.vue?vue&type=template&id=5a37f6ac&scoped=true&"
import script from "./loading6.vue?vue&type=script&lang=js&"
export * from "./loading6.vue?vue&type=script&lang=js&"
import style0 from "./loading6.scss?vue&type=style&index=0&id=5a37f6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37f6ac",
  null
  
)

export default component.exports